<template>
  <footer class="py-8 py-md-11 bg-gray-200">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 offset-md-2 col-lg-3 offset-lg-3 text-center align-self-center">

          <!-- Brand -->
          <router-link to="/" class="navbar-brand footer-brand img-fluid m-0 p-0">Sparkello</router-link>

          <!-- Text -->
          <p class="text-gray-700 mb-2">
            Find your spark
          </p>

          <!-- Social -->
          <ul class="list-unstyled list-inline list-social mb-6 mb-md-0">
            <li class="list-inline-item list-social-item mr-3">
              <a href="https://www.instagram.com/sparkelloapp/" class="text-decoration-none">
                <img src="/assets/img/icons/social/instagram.svg" class="list-social-icon" alt="...">
              </a>
            </li>
            <li class="list-inline-item list-social-item mr-3">
              <a href="https://www.facebook.com/sparkelloapp" class="text-decoration-none">
                <img src="/assets/img/icons/social/facebook.svg" class="list-social-icon" alt="...">
              </a>
            </li>
            <li class="list-inline-item list-social-item mr-3">
              <a href="https://twitter.com/sparkello" class="text-decoration-none">
                <img src="/assets/img/icons/social/twitter.svg" class="list-social-icon" alt="...">
              </a>
            </li>
            <li class="list-inline-item list-social-item mr-3">
              <a href="https://www.pinterest.com/sparkello" class="text-decoration-none">
                <img src="/assets/img/icons/social/pinterest.svg" class="list-social-icon" alt="...">
              </a>
            </li>
            <li class="list-inline-item list-social-item">
              <a href="mailto:support@sparkello.com" class="text-decoration-none">
                <img src="/assets/img/icons/social/email-outline.svg" class="list-social-icon" alt="...">
              </a>
            </li>
          </ul>

          <p class="text-center text-muted my-8">&copy; Sparkello Pty Ltd 2021</p>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-center pb-4">

          <!-- Heading -->
          <h6 class="font-weight-bold text-uppercase text-gray-700">
            Connect
          </h6>

          <!-- List -->
          <ul class="list-unstyled text-muted mb-0">
            <li class="mb-3">
              <router-link to="/contact" class="text-reset">Contact Us</router-link>
            </li>
            <li class="mb-3">
              <a href="https://blog.sparkello.com" class="text-reset">Blog</a>
            </li>
          </ul>


          <!-- Heading -->
          <h6 class="font-weight-bold text-uppercase text-gray-700 mt-6">
            Legal
          </h6>

          <!-- List -->
          <ul class="list-unstyled text-muted mb-0">
            <li class="mb-3">
              <a href="/privacy.html" class="text-reset">Privacy Policy</a>
            </li>
            <li class="mb-3">
              <a href="/terms.html" class="text-reset">Terms of Service</a>
            </li>
          </ul>

        </div>

      </div>
    </div>
  </footer>
</template>

<script>
import Vue from 'vue';

export default Vue.component('Footer', {
name: "Footer"
});
</script>

<style scoped>

</style>
